import React from 'react';
import { Button } from './ui/button';

const Header = () => {
  return (
    <header className="sticky top-0 z-50 bg-black/90 backdrop-blur-md shadow-lg border-b border-gray-800">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-center">
          <img
            src="https://jalwaaamazingg.site.pro/gallery/assets-img-logo.png?ts=1770386928"
            alt="jalwagameszone"
            className="h-12 md:h-16 w-auto object-contain"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
